export default String.raw`
const ComparerFullPopupUI = (() => {
    'use strict';
    const popupContainer = document.querySelector('.popup-js');

    if (!popupContainer) {
        return;
    }

    window.addEventListener('comparer:full', async () => {
        try {
            const response = await $.get(__ComparerLink, {
                __template: 'partials/product/comparison/comparer-full-popup.html',
            });
    
            if(!response || !response.template) {
                throw new Error("Error!")
            }
    
            popupContainer.innerHTML = response.template;
            popupContainer.querySelector('dialog')?.showModal();
        } catch (error) {
            console.error(error);
        }
    });
})();
`